goog.provide("shadow.js.shim.module$$embedpdf$react$stage");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$stage");
shadow.js.shim.module$$embedpdf$react$stage = shadow.js.nativeProvides["@embedpdf/react/stage"] = shadow$bridge("@embedpdf/react/stage");
module$shadow_js_shim_module$$embedpdf$react$stage.default = shadow.js.shim.module$$embedpdf$react$stage;
